import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper"; // ✅ Correct for v10+
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
export default function PackageCarousel({ images = [], title }) {
  // ✅ Normalize images (string → array)
  let parsedImages = [];

  try {
    parsedImages =
      typeof images === "string" ? JSON.parse(images) : images;

    if (!Array.isArray(parsedImages)) parsedImages = [];
  } catch {
    parsedImages = [];
  }

  if (!parsedImages.length) return null;

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      loop
      spaceBetween={20}
      slidesPerView={1}
    >
      {parsedImages.map((img, i) => (
        <SwiperSlide key={i}>
          <div style={{ position: "relative" }}>
            <img
              src={img.url}
              alt={`${title} slide ${i + 1}`}
              style={{
                width: "100%",
                height: "400px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />

            {/* ✅ Caption */}
            {img.caption && (
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0,0,0,0.55)",
                  color: "#fff",
                  padding: "10px 14px",
                  fontSize: "14px",
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
              >
                {img.caption}
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
